import React, { useContext } from 'react';
import { List } from '@sm/wds-react';

import { SubMenuItem } from '../components/SubMenuItem';
import SMHeaderContext from '../../../SMHeaderContext';

import { helpCenter, blog } from '../../../config/MobileLinkInfo';

import { showBlog } from '../../../../../helpers/languageHelpers.js';

export const HelpMenu = () => {
  const { lang } = useContext(SMHeaderContext);
  return (
    <List transparent>
      <SubMenuItem {...helpCenter()} />
      <SubMenuItem {...blog()} show={showBlog(lang)} />
    </List>
  );
};

export default HelpMenu;
